export enum SelectionToggleType {
  SelectUnselect,
  Reset,
}
